module.exports = __webpack_public_path__ + "img/smooth.d27fb8c4.png";